import MonthField from "./MonthField";

export default {
    init: function () {
        this.bind();
    },

    bind: function () {
        const _this = this;
        $(document).on("click", "[data-load_modal]", function (e) {
            e.preventDefault();

            const trigger = $(this);
            const url = new URL(trigger.data("load_modal"), window.location.origin);

            console.log(url);

            const data = {
                action: url.pathname.replace(/^\/+/, ""),
                security: settings.security,
            };
            const content = $("[data-modal_content]");
            const title = $("[data-modal_title]");

            if (trigger.is("[data-load_modal_title]")) {
                title.text(trigger.attr("data-load_modal_title"));
            }

            url.searchParams.forEach((value, key) => {
                data[key] = value;
            });

            content.html(_this.getLoader());
            MicroModal.show("cnt-modal");

            $.ajax({
                url: settings.ajaxurl,
                data: data,
                method: "GET",
                dataType: "json",
                success: (response) => {
                    setTimeout(() => {
                        content.html(response?.content);
                        MonthField.init();
                    }, 500);
                },
                error: (xhr) => {
                    const message = xhr.responseJSON?.message || "Nie udało się załadować formularza.";
                    const error = $("<div>", {
                        class: "cnt-form-error",
                        text: message,
                    });

                    content.empty().append(error);
                },
            });
        });
    },

    getLoader: function () {
        return `<div class="cnt-loader cnt-loader--visible">
            <div class="cnt-loader__icon"></div>
            <div class="cnt-loader__text">Proszę czekać...</div>
            </div>`;
    },
};
